module.exports = __webpack_public_path__ + "img/emo_54.14a437f3.png";